import { useEffect, useRef } from 'react'

import { setIsVisible } from '@editor/pages/projects/common/SolidMeshManager/store'
import { useAppDispatch, useAppSelector } from '@editor/store/app'
import { setLabelFontSize } from '@editor/store/tool'

import { setIsPcdVisible } from '../store/editor'

/**
 * Manages display settings lifecycle.
 */
const DisplaySettingsManager = () => {
  // Store
  const dispatch = useAppDispatch()
  const editorSettings = useAppSelector((state) => state.editorSettings.display)
  const labelSize = useAppSelector((state) => state.editorSettings.display.general.label_size)

  // Keep ref of editor settings to avoid re-triggering effects
  const editorSettingsRef = useRef(editorSettings)
  editorSettingsRef.current = editorSettings

  useEffect(() => {
    editorSettingsRef.current = editorSettings
  }, [editorSettings])

  /**
   * If label size of editor settings changes, update the label font size in tool store.
   */
  useEffect(() => {
    if (labelSize !== undefined) {
      dispatch(setLabelFontSize(labelSize))
    }
  }, [labelSize, dispatch])

  /**
   * Set initialize values on page hook completes.
   */
  useEffect(() => {
    const fn = () => {
      dispatch(setIsPcdVisible(editorSettingsRef.current.pcd.visible))
      dispatch(setIsVisible(editorSettingsRef.current.mesh.visible))
    }

    document.addEventListener('hooks:page:completed', fn)

    return () => {
      document.removeEventListener('hooks:page:completed', fn)
    }
  }, [dispatch])

  return null
}

export default DisplaySettingsManager
